'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.antDecorator = antDecorator;
function antDecorator(Vue) {
  return Vue.directive('decorator', {});
}

exports['default'] = {
  // just for tag
  install: function install(Vue) {
    antDecorator(Vue);
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/lib/_util/FormDecoratorDirective.js
// module id = 0xjq
// module chunks = 0